import React from "react";

export default function About() {
  return (
    <div id="company">
      <div id="solid">
        <h2>About me</h2>
        <p>
          Upon graduation, I will be quant trading at a bank or asset management
          firm. I envision this vividly because I hedged commodities on a trade
          floor with my supervisor at Cargill years ago. Thanks to my internship
          experience and coach from Management Leadership for Tomorrow, I
          understand the sense of urgency and accuracy that traders must
          possess. Additionally, I envision passing the securities industry
          essentials exam, series 7 and series 57 within my first 6 - 8 months
          at the desk. I even reviewed half of the SIE study manual along with
          information from Investopedia for understanding technical jargon.
          Furthermore, I developed the habit to read market news articles from
          the Wall Street Journal, Barron’s, Bloomberg, and Yahoo Finance. And I
          am grateful Baruch introduced the WSJ free to undergrads. Most
          recently, I began my software engineering course at Per Scholas to
          streamline enhancing my programming and I completed Tim Buchalka’s
          Python Masterclass successfully. Through Per Scholas’ 15-week course,
          I am building websites, application programming interfaces, and other
          projects through JavaScript, React, JSON, HTML, and CSS. Thanks to my
          python dedication, I have fully completed all the test inputs for over
          twenty Python HackerRank function implementation challenges.
        </p>
        <p>
          I hold myself accountable for my professional development. I know
          exactly where I want to be, and I know the pinnacles I aspire to
          reach. I will be a great fit for this program because I harnessed my
          willpower to overcome any obstacles I encounter.
        </p>
      </div>
    </div>
  );
}
